/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Max range info popup
document.addEventListener('DOMContentLoaded', function() {
    const infoButtons = document.querySelectorAll('.product-form__option-name--info');
    
    infoButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        
        let infoContent = this.nextElementSibling;
        if (!infoContent || !infoContent.classList.contains('product-form__option-name--info-content')) {
          infoContent = this.parentElement.querySelector('.product-form__option-name--info-content');
        }
        
        if (infoContent) {
          infoContent.style.display = 'block';
        }
      });
    });
    
    const closeButtons = document.querySelectorAll('.product-form__option-name--info-content--close');
    closeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        const infoContent = this.closest('.product-form__option-name--info-content');
        if (infoContent) {
          infoContent.style.display = 'none';
        }
      });
    });
    
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.product-form__option-name--info-content') && 
          !e.target.closest('.product-form__option-name--info')) {
        const infoContents = document.querySelectorAll('.product-form__option-name--info-content');
        infoContents.forEach(content => {
          content.style.display = 'none';
        });
      }
    });
    
    // Global function to update delivery labels (for custom-products-cards section)
    window.updateDeliveryLabel = function(variant, itemElement) {
      const availableLabel = itemElement.querySelector('.product_gallery--item-available');
      const comingSoonLabel = itemElement.querySelector('.product_gallery--item-coming-soon');
      const soldOutLabel = itemElement.querySelector('.product_gallery--item-sold-out');
      
      if (!variant) return;
      
      // New inventory-based logic
      const inventoryQuantity = variant.inventory_quantity || 0;
      const inventoryPolicy = variant.inventory_policy || 'deny';
      
      // In-stock: inventory > 0
      const isInStock = inventoryQuantity > 0;
      
      // Preorder: inventory <= 0 and continue selling is enabled
      const isPreorder = inventoryQuantity <= 0 && inventoryPolicy === 'continue';
      
      // Out of stock: inventory <= 0 and continue selling is disabled
      const isOutOfStock = inventoryQuantity <= 0 && inventoryPolicy === 'deny';
      
      // Show/hide labels based on inventory status
      if (availableLabel) {
        availableLabel.style.display = isInStock ? 'flex' : 'none';
      }
      
      if (comingSoonLabel) {
        comingSoonLabel.style.display = isPreorder ? 'block' : 'none';
        if (isPreorder) {
          const valueSpan = comingSoonLabel.querySelector('.coming-soon-value');
          if (valueSpan) {
            const preorderText = variant.preorder_text || '';
            const incomingDate = variant.incoming_date_single || '';
            if (preorderText) {
              valueSpan.textContent = `Vorbestellbar. ${preorderText}`;
            } else if (incomingDate) {
              const date = new Date(incomingDate);
              const formattedDate = date.toLocaleDateString('de-DE');
              valueSpan.textContent = `Vorbestellbar. Voraussichtlich verfügbar ab ${formattedDate}`;
            } else {
              valueSpan.textContent = 'Vorbestellbar';
            }
          }
        }
      }
      
      if (soldOutLabel) {
        soldOutLabel.style.display = isOutOfStock ? 'flex' : 'none';
      }
    };
    
    // Product gallery variant switcher
    const galleryItems = document.querySelectorAll('gallery-item');
    
    galleryItems.forEach(item => {
      const variantInputs = item.querySelectorAll('.variant-option-input');
      const variantsDataDiv = item.querySelector('[data-variants-data]');
      const priceContainer = item.querySelector('.products_gallery--item-price');
      const metafieldsContainer = item.querySelector('.variant-metafields');
      const detailedSpecsContainer = item.querySelector('.detailed-specs');
      const variantAccordion = item.querySelector('.variant-accordion');
      
      if (!variantsDataDiv) return;
      
      const variantsData = JSON.parse(variantsDataDiv.dataset.variantsData || '{}');
      const productId = variantsDataDiv.dataset.productId;
      
      function findVariantByOptions(selectedOptions) {
        for (const [variantId, variantData] of Object.entries(variantsData)) {
          if (JSON.stringify(variantData.options) === JSON.stringify(selectedOptions)) {
            return { id: variantId, ...variantData };
          }
        }
        return null;
      }
      
      function checkAvailabilityForFirstOption(firstOptionValue) {
        // Check if any variant with this first option value is in stock, preorder, or out of stock
        // This checks ALL possible combinations with the second option
        let hasInStockVariant = false;
        let hasPreorderVariant = false;
        
        for (const [variantId, variantData] of Object.entries(variantsData)) {
          // Check if this variant has the selected first option (regardless of second option)
          if (variantData.options && variantData.options[0] === firstOptionValue) {
            const inventoryQuantity = variantData.inventory_quantity || 0;
            const inventoryPolicy = variantData.inventory_policy || 'deny';
            
            // Check for in-stock (inventory > 0)
            if (inventoryQuantity > 0) {
              hasInStockVariant = true;
            }
            
            // Check for preorder (inventory <= 0 and continue selling)
            if (inventoryQuantity <= 0 && inventoryPolicy === 'continue') {
              hasPreorderVariant = true;
            }
          }
        }
        
        return { hasAvailable: hasInStockVariant, hasPreorder: hasPreorderVariant };
      }
      
      function updatePriceDisplay(variant) {
        if (!priceContainer || !variant) return;
        
        const priceStr = variant.price;
        const compareAtPriceStr = variant.compare_at_price;
        
        let priceSpan = priceContainer.querySelector('.price:not(.price--compare)');
        let compareSpan = priceContainer.querySelector('.price--compare');
        
        if (compareAtPriceStr && compareAtPriceStr.trim() !== '') {
          const priceNum = parseFloat(priceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
          const compareNum = parseFloat(compareAtPriceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
          
          if (compareNum > priceNum) {
            if (!priceSpan || !priceSpan.classList.contains('price--sale')) {
              priceContainer.innerHTML = `
                <span class="price price--sale">${priceStr}</span>
                <span class="price price--compare">${compareAtPriceStr}</span>
              `;
            } else {
              priceSpan.textContent = priceStr;
              compareSpan.textContent = compareAtPriceStr;
            }
          } else {
            if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
              priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
            } else {
              priceSpan.textContent = priceStr;
            }
          }
        } else {
          if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
            priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
          } else {
            priceSpan.textContent = priceStr;
          }
        }
      }
      
      function updateMetafields(variant) {
        if (!metafieldsContainer || !variant) return;
        
        const metafields = ['steigfahigkeit', 'max_zuladung', 'peakleistung', 'gewicht'];
        metafields.forEach(field => {
          const metafieldItem = metafieldsContainer.querySelector(`[data-metafield="${field}"]`);
          if (metafieldItem) {
            const valueSpan = metafieldItem.querySelector('.metafield-value');
            if (variant[field]) {
              metafieldItem.style.display = '';
              if (valueSpan) valueSpan.textContent = variant[field];
            } else {
              metafieldItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateDetailedSpecs(variant) {
        if (!detailedSpecsContainer || !variant) return;
        
        const specs = ['wattstunden_akku', 'ladezeit', 'federung_vorne', 'federung_hinten', 
                       'bremssystem_vorne', 'bremssystem_hinten', 'blinker', 'ip_schutzgrad'];
        specs.forEach(field => {
          const specItem = detailedSpecsContainer.querySelector(`[data-metafield="${field}"]`);
          if (specItem) {
            const valueSpan = specItem.querySelector('.spec-value');
            if (variant[field]) {
              specItem.style.display = '';
              if (valueSpan) valueSpan.textContent = variant[field];
            } else {
              specItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateVariantDescription(variant) {
        if (!variantAccordion || !variant) return;
        
        const valueSpan = variantAccordion.querySelector('.metafield-value');
        if (variant.varianten_beschreibung) {
          variantAccordion.style.display = '';
          if (valueSpan) valueSpan.textContent = variant.varianten_beschreibung;
        } else {
          variantAccordion.style.display = 'none';
        }
      }
      
      // Initialize delivery label on page load with first variant
    const initialSelectedOptions = [];
    const initialCheckedInputs = item.querySelectorAll('.variant-option-input:checked');
    initialCheckedInputs.forEach(checked => {
      initialSelectedOptions.push(checked.dataset.optionValue);
    });
    
    // Check if second option is hidden (geschwindigkeit)
    const geschwindigkeitOption = item.querySelector('[data-option-name="geschwindigkeit"]');
    const isGeschwindigkeitHidden = geschwindigkeitOption && (
      geschwindigkeitOption.style.display === 'none' || 
      window.getComputedStyle(geschwindigkeitOption).display === 'none'
    );

    if (isGeschwindigkeitHidden && initialSelectedOptions.length >= 1) {
      // If geschwindigkeit is hidden, check all variants with the first option
      const result = checkAvailabilityForFirstOption(initialSelectedOptions[0]);
      const availableLabel = item.querySelector('.product_gallery--item-available');
      const soldOutLabel = item.querySelector('.product_gallery--item-sold-out');
      const comingSoonLabel = item.querySelector('.product_gallery--item-coming-soon');
      
      if (result.hasPreorder) {
        // Show coming soon for preorder
        if (availableLabel) availableLabel.style.display = 'none';
        if (soldOutLabel) soldOutLabel.style.display = 'none';
        if (comingSoonLabel) comingSoonLabel.style.display = 'block';
      } else if (result.hasAvailable) {
        // Show available
        if (availableLabel) availableLabel.style.display = 'flex';
        if (soldOutLabel) soldOutLabel.style.display = 'none';
        if (comingSoonLabel) comingSoonLabel.style.display = 'none';
      } else {
        // Show sold out
        if (availableLabel) availableLabel.style.display = 'none';
        if (soldOutLabel) soldOutLabel.style.display = 'flex';
        if (comingSoonLabel) comingSoonLabel.style.display = 'none';
      }
    } else {
      // Normal case - use exact variant match
      const initialVariant = findVariantByOptions(initialSelectedOptions);
      if (initialVariant) {
        window.updateDeliveryLabel(initialVariant, item);
      }
    }
    
    variantInputs.forEach(input => {
      input.addEventListener('change', function(e) {
        if (e.target.dataset.handledBySection) return;
        
        const selectedOptions = [];
        const checkedInputs = item.querySelectorAll('.variant-option-input:checked');
        checkedInputs.forEach(checked => {
          selectedOptions.push(checked.dataset.optionValue);
        });
        
        // Check if second option (geschwindigkeit) is hidden
        const geschwindigkeitOption = item.querySelector('[data-option-name="geschwindigkeit"]');
        const isGeschwindigkeitHidden = geschwindigkeitOption && (
          geschwindigkeitOption.style.display === 'none' || 
          window.getComputedStyle(geschwindigkeitOption).display === 'none'
        );
        
        // If geschwindigkeit is hidden, check availability across all second option values
        if (isGeschwindigkeitHidden && selectedOptions.length >= 1) {
          const result = checkAvailabilityForFirstOption(selectedOptions[0]);
          const availableLabel = item.querySelector('.product_gallery--item-available');
          const soldOutLabel = item.querySelector('.product_gallery--item-sold-out');
          const comingSoonLabel = item.querySelector('.product_gallery--item-coming-soon');
          
          if (result.hasPreorder) {
            // Show coming soon for preorder
            if (availableLabel) availableLabel.style.display = 'none';
            if (soldOutLabel) soldOutLabel.style.display = 'none';
            if (comingSoonLabel) comingSoonLabel.style.display = 'block';
          } else if (result.hasAvailable) {
            // Show available
            if (availableLabel) availableLabel.style.display = 'flex';
            if (soldOutLabel) soldOutLabel.style.display = 'none';
            if (comingSoonLabel) comingSoonLabel.style.display = 'none';
          } else {
            // Show sold out
            if (availableLabel) availableLabel.style.display = 'none';
            if (soldOutLabel) soldOutLabel.style.display = 'flex';
            if (comingSoonLabel) comingSoonLabel.style.display = 'none';
          }
          
          // Still update other info with the first available variant or first matching variant
          let firstMatchingVariant = Object.entries(variantsData).find(([id, data]) => 
            data.options[0] === selectedOptions[0] && data.available
          );
          
          // If no available variant, just use first matching
          if (!firstMatchingVariant) {
            firstMatchingVariant = Object.entries(variantsData).find(([id, data]) => 
              data.options[0] === selectedOptions[0]
            );
          }
          
          if (firstMatchingVariant) {
            const variantData = { id: firstMatchingVariant[0], ...firstMatchingVariant[1] };
            updatePriceDisplay(variantData);
            updateMetafields(variantData);
            updateDetailedSpecs(variantData);
            updateVariantDescription(variantData);
          }
        } else {
          // Full variant selected - use normal logic
          const variant = findVariantByOptions(selectedOptions);
          
          if (variant) {
            updatePriceDisplay(variant);
            updateMetafields(variant);
            updateDetailedSpecs(variant);
            updateVariantDescription(variant);
            window.updateDeliveryLabel(variant, item);
          }
        }
      });
    });
  });
});  